module.exports = __webpack_public_path__ + "img/member-header-logo.png";